module.exports = __webpack_public_path__ + "img/continous.9f6a7bf4.svg";